<onsip-header-main>
  <onsip-header-page-title>{{ "ONSIP_I18N.PBX_SETTINGS" | translate }}</onsip-header-page-title>
</onsip-header-main>
<div class="settings-container">
  <router-outlet></router-outlet>
</div>
